import { Navbar } from 'framework7-react';
import React      from 'react';


export default function EmptyPage() {
  return (
    <React.Fragment>
      <Navbar title=""/>
      <div className="page-content"></div>
    </React.Fragment>
  );
}

